export default "__VITE_ASSET__DYWWy6Pk__"